import { getPlatform } from "./platformRef";

/** Whether the app shell holds the sign-in outside the page (the desktop's vault, the iOS
 *  Keychain): the platform answers `auth.getSession`, and the Stytch JS client is empty. */
export function shellHoldsSession(): boolean {
    return getPlatform().auth.getSession !== undefined;
}
